module.exports = __webpack_public_path__ + "static/media/send-message.22dca465.png";